// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PriceListController = function ($scope,
    $rootScope,
    $http,
    $routeParams,
    $q,
    $location,
    gettext,
    gettextCatalog,
    PriceList,
    PlanGroup,
) {
    
    $scope.showHidden = false;
    $scope.planGroupId = $routeParams.planGroupId;
    $scope.planGroup = PlanGroup.get({ planGroupId: $scope.planGroupId });
    if (!$scope.search)
        $scope.search = "";

    function getSearchParams() {
        var searchParams = {
            search: $scope.search,
            showHidden: $scope.showHidden,
            planGroupId: $scope.planGroupId
        };
        return searchParams;
    }

    $scope.updateFilter = function () {
        PriceList.query(getSearchParams()).$promise.then(
            function (response) {
                
                $scope.fullPriceListItems = response.map(obj => ({ ...obj, Id: obj.Id }));
                $scope.priceLists = $scope.paginator(function (options, callback) {
                    let list = null;
                    let index = 0;
                    if (options.from !== "") {
                        index = $scope.fullPriceListItems.findIndex(x => x.Id === options.from)
                    }
                    list = $scope.fullPriceListItems.slice(index, index + options.take);
                    let query = function (success) {
                        let deferred = $q.defer();
                        let promise = deferred.promise;
                        promise.then(success);
                        deferred.resolve(list);
                        return promise.$$state.value;
                    };
                    return query(function () {
                        if ($scope.unsavedItems > 0) {
                            return;
                        }
                        callback();
                    });
                }, getSearchParams(), 20);
                
                $scope.priceLists.first = $scope.overrideStep($scope.priceLists.first);
                $scope.priceLists.next = $scope.overrideStep($scope.priceLists.next);
                $scope.priceLists.prev = $scope.overrideStep($scope.priceLists.prev);
            }
        );
    };
    
    $scope.canInheritPriceList = function (priceList) {
        var maxInheritLimit = 10;
        var index = 1;
        var parentPriceListId = priceList.ParentPriceListId;
        
        while (parentPriceListId) {
            index++;
            //here items is property of array in $scope.priceLists.items. It is not PriceLis.Items 
            var parentPriceLists = $scope.fullPriceListItems.filter(priceList => priceList.Id === parentPriceListId);
            switch (parentPriceLists.length) {
                case 0:
                    parentPriceListId = null;
                    break;
                case 1:
                    parentPriceListId = parentPriceLists[0].ParentPriceListId;
                    break;
                default:
                    parentPriceListId = null;
                    $rootScope.notify(`Price list with id ${priceListId} not found or there are more than single item.`);
                    break;
            }
        }
        //here check less than only because we do not want to show inherit button for last(10th) item in list
        return index < maxInheritLimit;
    };

    $scope.getPriceListById = function (priceListId) {
        if (!priceListId || !$scope.priceLists || !$scope.priceLists.items) 
            return null;
        let priceLists = $scope.priceLists.items.filter(priceList => priceList.Id === priceListId);
        if (priceLists.length !== 1) {
            $rootScope.notify(`Price list with id ${priceListId} not found or there are more than single item.`);
            return null;
        }
        return priceLists[0];
    };
    
    $scope.hasChildPriceLists = function(parentId, hiddenOnly = null) {
        if (!parentId) return false;
        return $scope.getChildPriceLists(parentId, hiddenOnly).length > 0;
    };
    $scope.getParentPriceList = function (childId) {
        if (!childId) return false;
        let priceLists = $scope.priceLists.items.filter(priceList => priceList.Id === childId);
        if (priceLists.length == 1 && priceLists[0]?.ParentPriceListId?.length > 0) {
            return $scope.getPriceListById(priceLists[0].ParentPriceListId);
        }
        return null;
    };
    $scope.getChildPriceLists = function(parentId, hiddenOnly = null) {
        return (!$scope.priceLists || !$scope.priceLists.items)
            ? []
            : $scope.priceLists.items.filter(priceList => priceList.ParentPriceListId === parentId && (hiddenOnly === null || priceList.Hidden === hiddenOnly));
    };
    $scope.updateFilter();

    $scope.hideShowItems = function () {
        $scope.showHidden = !$scope.showHidden;
        $scope.updateFilter();
    };

    $scope.deletePriceList = function (priceList) {
        if ($scope.hasChildPriceLists(priceList.Id )){
            $scope.cancel(_txt(gettext('This price list has other price lists inherited from it. Please delete the child price lists first.')));
            return;
        }
        $scope.yesCancel(_txt(gettext('You are about to delete a price list.')),
            _txt(gettext('Are you sure?')),
            function () {
                PriceList.remove({ priceListId: priceList.Id }, function () {
                    $scope.updateFilter();
                });
            });
    };

    function changeItemVisibility(id, hide, unhideChildren = false) {
        $http({
            method: "POST",
            url: `/api/v1/pricelists/${id}/visibility`,
            data: { "Id": id, "Hidden": hide, "UnhideChildren": unhideChildren },
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function () {
            $scope.updateFilter();
        });
    }

    function _txt(msg) {
        return gettextCatalog.getString(msg);
    }

    function confirm(header, callback) {
        $scope.yesCancel(header, gettextCatalog.getString(gettext('Are you sure?')), function () { callback(); });
    }

    function confirmWithChoice(content) {
        $scope.yesNoCancel(content.header, _txt(gettext('Are you sure?')), content.yesCallback, content.noCallback, content.cancelCallback);
    }

    $scope.hideItem = function (id, $event) {
        // When hiding a parent with visible children, show a warning and hide all the children
        confirm(gettextCatalog.getString(gettext('You are about to hide an item. This action will also hide other price lists that inherit from this price list.')),
                function () {
                    changeItemVisibility(id, true);
                });        
        $event.stopPropagation();
    };

    $scope.unhideItem = function (id, $event) {
        // When attempting to unhide a child with a hidden parent, show an error
        // when unhiding a parent with hidden children, ask if the children should remain hidden, or if they should all be made visible.

        let parentPriceList = $scope.getParentPriceList(id);

        if (parentPriceList && parentPriceList.Hidden === true) {
            $rootScope.notifyCustomError(`This action cannot be performed since this price list with id ${id} has a hidden parent.`);
            $event.stopPropagation();
            return;
        }
        else {
            let childPriceLists = $scope.getChildPriceLists(id, true);
            if (childPriceLists?.length > 0) {
                confirmWithChoice({
                    header: gettextCatalog.getString(gettext('This price list is inherited by other price lists which are also hidden. Do you want to unhide them also?')),
                    yesCallback: function () {
                        changeItemVisibility(id, false, unhideChildren = true);
                    },
                    noCallback: function () {
                        changeItemVisibility(id, false);
                    },
                    cancelCallback: function () {
                    }
                });
            }
            else {
                confirm(gettextCatalog.getString(gettext('You are about to make an item visible again.')),
                    function () {
                        changeItemVisibility(id, false);
                    });        
            }
            $event.stopPropagation();
        }
    };

    $scope.createInheritedPriceList = function (priceListId, $event) {
        confirm(gettextCatalog.getString(gettextCatalog.getString(gettext('You are about to create an inherited price list including all assignments.'))),
            function () {
                postCreteInheritedPriceList(priceListId);
            });
        $event.stopPropagation();
    }
    $scope.clonePriceList = function (priceListId, $event) {
        confirm(gettextCatalog.getString(gettextCatalog.getString(gettext('You are about to duplicate a price list including all assignments.'))),
            function () {
                postClonePriceList(priceListId);
            });
        $event.stopPropagation();
    }

    $scope.navigateToCreatePriceList = function() {
        $location.path(`/plangroups/${$scope.planGroupId}/pricelists/create`);
    };
    
    function postCreteInheritedPriceList(priceListId) {
        $http({
            method: "POST",
            url: "/api/v1/pricelists/" + priceListId + "/createinherited",
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function (response) {
            window.location.href = "#/pricelists/" + response.data.Id + "/edit";
        });
    }
    function postClonePriceList(priceListId) {
        $http({
            method: "POST",
            url: "/api/v1/pricelists/" + priceListId + "/clone",
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function (response) {
            window.location.href = "#/pricelists/" + response.data.Id + "/edit";
        });
    }
};
PriceListController.$inject = ['$scope', '$rootScope', '$http', '$routeParams', '$q', '$location', 'gettext', 'gettextCatalog', 'PriceList', 'PlanGroup'];
